import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './auth';
import { useTheme } from './theme';
import { useOnboardingActive } from './onboardingContext';
import { visibleModules } from '../modules';
import { BottomNav } from './BottomNav';
import { Icon } from './Icon';
import { NotificationSettings } from './NotificationSettings';

export function Layout() {
  const { boot, logout } = useAuth();
  const { isDark, setTheme } = useTheme();
  const onboarding = useOnboardingActive();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);

  if (!boot) return null;
  const all = visibleModules(boot.me.isAdmin);
  const bottom = all.filter((m) => m.showInBottomNav);
  // 설정(어드민)은 헤더 톱니로 빼므로 "더보기"에서 제외. 이후 일반 모듈이 늘면 자동 노출.
  const more = all.filter((m) => !m.showInBottomNav && !m.adminOnly);

  return (
    <div className="mx-auto flex h-full max-w-md flex-col overflow-hidden bg-surface">
      <header className="flex items-center justify-between border-b border-line bg-surface px-4 py-3 pt-safe">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-lg font-bold text-ink tap-bounce"
        >
          <Icon name="Heart" size={20} className="text-accentA" fill="currentColor" />
          <span className="font-round">{boot.settings.appName}</span>
        </button>
        <div className="flex items-center gap-1">
          {boot.me.isAdmin && (
            <button
              aria-label="설정"
              onClick={() => navigate('/admin')}
              className="flex h-10 w-10 items-center justify-center rounded-full text-ink-soft tap-bounce hover:bg-surface-soft"
            >
              <Icon name="Settings" size={20} />
            </button>
          )}
          <button
            aria-label="알림 설정"
            onClick={() => setNotifOpen(true)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-ink-soft tap-bounce hover:bg-surface-soft"
          >
            <Icon name="Bell" size={20} />
          </button>
          <button
            aria-label="테마 전환"
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            className="flex h-10 w-10 items-center justify-center rounded-full text-ink-soft tap-bounce hover:bg-surface-soft"
          >
            <Icon name={isDark ? 'Sun' : 'Moon'} size={20} />
          </button>
          <button
            aria-label="로그아웃"
            onClick={() => logout()}
            className="flex h-10 w-10 items-center justify-center rounded-full text-ink-soft tap-bounce hover:bg-surface-soft"
          >
            <Icon name="LogOut" size={20} />
          </button>
        </div>
      </header>

      {/* 본문만 내부 스크롤 → 하단탭은 fixed 없이 칼럼 바닥에 고정(모바일 동적 뷰포트 드리프트 방지) */}
      <main className="flex-1 overflow-y-auto px-4 pb-6 pt-4">
        <Outlet />
      </main>

      {/* 온보딩 중에는 하단탭을 숨겨 메뉴 스포일러를 막는다. */}
      {!onboarding && (
        <BottomNav items={bottom} hasMore={more.length > 0} onMore={() => setMoreOpen(true)} />
      )}

      {notifOpen && <NotificationSettings onClose={() => setNotifOpen(false)} />}

      {moreOpen && (
        <div
          className="fixed inset-0 z-40 flex items-end bg-black/30"
          onClick={() => setMoreOpen(false)}
        >
          <div
            className="mx-auto w-full max-w-md rounded-t-3xl border-t border-line bg-card p-4 pb-safe"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-3 flex items-center justify-between">
              <h2 className="font-round text-lg font-bold text-ink">더보기</h2>
              <button
                onClick={() => setMoreOpen(false)}
                className="flex h-9 w-9 items-center justify-center rounded-full text-ink-soft hover:bg-surface-soft"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
            <div className="grid grid-cols-3 gap-3">
              {more.map((m) => (
                <button
                  key={m.id}
                  onClick={() => {
                    setMoreOpen(false);
                    navigate(m.route);
                  }}
                  className="flex flex-col items-center gap-2 rounded-2xl bg-surface-soft p-4 text-ink tap-bounce"
                >
                  <Icon name={m.icon} size={24} className="text-accentA" />
                  <span className="text-xs">{m.title}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
